import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { TypographyT5 } from '@picsart/design-system/foundation/typography';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      color: TextColors.base,
      marginTop: Spacings.s40,
    },

    text: {
      marginBottom: Spacings.s40,
      textAlign: 'center',
    },

    tableContainer: {
      overflowX: 'auto',
      maxWidth: '100%',
      width: '100%',
    },

    table: {
      borderCollapse: 'collapse',
      color: TextColors.base,
      fontWeight: FontWeights.medium,
      textAlign: 'left',
      width: '100%',

      ...TypographyT5,

      '@media screen and (max-width: 480px)': {
        width: 478,
      },

      '& th': {
        backgroundColor: BackgroundColors.tint3,
        fontWeight: FontWeights.semibold,
        padding: [Spacings.s12, Spacings.s16],
        width: '33%',
      },

      '& td': {
        padding: [Spacings.s12, Spacings.s16],
        width: '33%',

        '&:first-child': {
          color: TextColors.tint2,
        },
      },

      '& tr:nth-child(even)': {
        backgroundColor: BackgroundColors.tint1,
      },
    },
  },
  {
    name: 'color-table',
  },
);

export default useStyles;
